import { toast } from "react-toastify";
import { announce } from "./LiveRegion";

// A11Y-10: errors interrupt (assertive), everything else is polite.
const STATUS_ROLE = "status";
const ALERT_ROLE = "alert";

// A11Y-10: also push polite toasts through the LiveRegion — Toastify sets
// role="status" after its enter transition, which Narrator often misses.
const mirror = (message) => {
    if (typeof message === "string") announce(message);
};

const CustomToast = {
    success: (message) => {
        mirror(message);
        return toast.success(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
            role: STATUS_ROLE
        });
    },
    info: (message) => {
        mirror(message);
        return toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
            role: STATUS_ROLE
        });
    },
    warn: (message) => {
        mirror(message);
        return toast.warn(message, {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
            role: STATUS_ROLE
        });
    },
    error: (message) => {
        // role="alert" is announced reliably on all screen readers — no mirror needed.
        return toast.error(message, {
            position: "top-center",
            autoClose: 7000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
            role: ALERT_ROLE
        });
    },
    update: (existingToast, message, type) => {
        // Mirror polite variants only; errors already announce via role="alert".
        if (type !== "loading" && type !== "error") mirror(message);
        let toastType;

        if (type === "success") {
            toastType = toast.TYPE.SUCCESS;
        } else if (type === "error") {
            toastType = toast.TYPE.ERROR;
        } else if (type === 'loading') {
            toastType = toast.TYPE.DEFAULT
        } else {
            toastType = toast.TYPE.INFO;
        }
        return toast.update(existingToast, {
            render: message,
            type: toastType,
            position: "top-center",
            autoClose: type === "loading" ? false : 7000,
            isLoading: type === "loading" ? true : false,
            closeButton: type === 'loading' ? false : true,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
            role: type === "error" ? ALERT_ROLE : STATUS_ROLE
        });
    },
    promise: (prom, details) => {
        return toast.promise(prom, details, {
            position: "top-center",
            autoClose: 7000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "dark",
            role: STATUS_ROLE
        });
    },
    dismissToast: (toastObj) => {
        toast.dismiss(toastObj);
    },
    loading: (message) => {
        return toast.loading(message, {
            position: "top-center",
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            theme: "dark",
            role: STATUS_ROLE
        });
    }
}

export default CustomToast;
